import { render } from "./ProfilePicture.vue?vue&type=template&id=cac0bb8c"
import script from "./ProfilePicture.vue?vue&type=script&lang=js"
export * from "./ProfilePicture.vue?vue&type=script&lang=js"

import exportComponent from "F:\\-=Projects=-\\Sites\\map\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__